export const SET_LOADER = 'SET_LOADER'
export const SET_SUBMISSION_ERROR = 'SET_SUBMISSION_ERROR'